export const classNames = (...args: (string | null | undefined)[]) => args.filter(Boolean).join(' ');